<template>
  <div class="app">
    <TotalAvaliacoes
      :labels="labelsNotas"
      :valores="valoresNotasTotal"
      :notasTotal="notasTotal"
      :idFila="idFila"
    />
    <v-divider class="mx-2" />
    <AvaliacoesPorOperador :labels="labelsNotas" :operadores="operadores" :avaliacoesOperadores="avaliacoesOperadores" :idFila="idFila" />
    <v-divider class="mx-2" />
    <TableDiasCorridos :labels="labelsNotas" :diasCorridos="labelNotasDiaCorrido" :avaliacoesDiasCorridos="valoresNotasDiasCorrido" />
  </div>
</template>

<script>
import TotalAvaliacoes from './TotalAvaliacoes'
import TableDiasCorridos from './TableDiasCorridos'
import AvaliacoesPorOperador from './AvaliacoesPorOperador'

export default {
  name: 'LayoutRelatorioResumidoPesquisaSatisfacao',
  props: {
    valoresNotasTotal: Array,
    labelsNotas: Array,
    notasTotal: Object,
    labelNotasDiaCorrido: Array,
    valoresNotasDiasCorrido: Array,
    operadores: Array,
    avaliacoesOperadores: Array,
    idFila: String,
  },
  components: { TotalAvaliacoes, TableDiasCorridos, AvaliacoesPorOperador },
}
</script>
